module.exports = __webpack_public_path__ + "img/carlos-perez.71b77925.png";